module.exports = __webpack_public_path__ + "img/part-5-title.cb62d78a.png";